export const getScoreAsPercentage = (achieved: number, achievable: number): number => {
  if (achievable === 0) return 0;
  return Math.round((achieved / achievable) * 100);
};

export const getMessageForPercentage = (
  percentage: number,
  veryGoodMessage: string,
  wellDoneMessage: string,
  badMessage: string,
): string => {
  if (percentage > 66) return veryGoodMessage;
  if (percentage > 33) return wellDoneMessage;
  return badMessage;
};
